const account_model = {
    "name" :'',
    "logo" :'',
    "colorBoton" :'',
    "colorTextBoton" :'',
    "colorFeatured":''
};
export default account_model;